import { Checkbox, SxProps } from '@mui/material';
import { StacklineTheme, useStacklineTheme } from '@stackline/ui';
import React from 'react';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import { SlSelectedCheckbox, SlUnselectedCheckbox } from 'src/components/SvgIcons';
import FormControlLabel from '@mui/material/FormControlLabel';

export enum CheckboxDimensions {
  DEFAULT_WIDTH = '16px',
  DEFAULT_HEIGHT = '16px'
}

const CheckboxItem = ({
  label,
  value,
  theme,
  checked,
  onClick,
  checkedIcon = (
    <SlSelectedCheckbox
      style={{ width: CheckboxDimensions.DEFAULT_WIDTH, height: CheckboxDimensions.DEFAULT_HEIGHT }}
    />
  ),
  disabled,
  textSx
}: {
  label: string;
  value: string | number;
  theme?: StacklineTheme;
  checked?: boolean;
  onClick?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  checkedIcon?: React.ReactNode;
  disabled?: boolean;
  textSx?: SxProps;
}) => {
  const themeFallback = useStacklineTheme();
  theme = theme ?? themeFallback;

  return (
    <FormControlLabel
      disabled={disabled}
      title={label}
      onChange={onClick}
      value={value}
      control={
        <Checkbox
          checkedIcon={checkedIcon}
          icon={
            <SlUnselectedCheckbox
              style={{ width: CheckboxDimensions.DEFAULT_WIDTH, height: CheckboxDimensions.DEFAULT_HEIGHT }}
            />
          }
          checked={checked}
          disableRipple
          disableTouchRipple
          sx={{
            '&, &.Mui-checked': {
              color: theme.colors.primary
            }
          }}
        />
      }
      label={
        <Text
          variant="body2"
          sx={{
            letterSpacing: 0.28,
            maxWidth: '150px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            color: disabled ? '#bec7d3' : theme.colors.primary,
            ...(textSx ?? {})
          }}
        >
          {label}
        </Text>
      }
      sx={{
        margin: '0',
        alignItems: 'center',
        height: '19px',
        gap: '8px',
        flexShrink: 0,
        width: 'fit-content',
        '& .MuiSwitch-switchBase': {
          padding: '0'
        },
        '& span': {
          padding: '0'
        }
      }}
    />
  );
};

export default CheckboxItem;
